import React from "react";

const LastWorship = () => {
  return (
    <section className="p-6 md:p-8 text-center bg-green-900">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">Final Worship Song</h2>

      <div className="flex justify-center">
        <div className="w-full max-w-4xl aspect-video rounded-xl overflow-hidden shadow-lg">
          <iframe
            className="w-full h-full"
            src="https://www.youtube.com/embed/YTeWThXzavs"
            title="Last Worship Song"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default LastWorship;